export default __webpack_public_path__ + "static/media/charles-manson.7b18e84e.jpg";